import React, { useState,useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import ErrorScreen from "../components/ErrorScreen";
import { useUser } from "../context/UserContext";
import AlertModal from "../components/AlertModal";
import { useAlertModal } from "../hooks/useAlertModal";
import Modal from "../components/Modal";


const AgencyManagement = () => {
  const { userInfo } = useUser(); // 로그인한 유저 정보
  const [users, setUsers] = useState([]);
  const [isMiniTabOpen, setMiniTabOpen] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [tempSelectedUser, setTempSelectedUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState("대리점"); // 기본값: 대리점
  const [rakeRate, setRakeRate] = useState(5); // 기본값: 5%
  const [loading, setLoading] = useState(true); // 로딩 상태 추가
  const [error, setError] = useState(null); // 에러 처리
  const [availableUsers, setAvailableUsers] = useState([]);
  const [page, setPage] = useState(0); // 페이지 번호
  const [size, setSize] = useState(10); // 페이지 크기
  const [totalPages, setTotalPages] = useState(0);
  const [parentUsers, setParentUsers] = useState([]); // 부모 유저 목록
  const [selectedParent, setSelectedParent] = useState(userInfo ? userInfo.username : ""); // 로그인한 유저를 기본 부모로 설정
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [detailUser, setDetailUser] = useState(null);
  const [memo, setMemo] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [activeFilter, setActiveFilter] = useState(""); 

    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [isRegisterOpen, setRegisterOpen] = useState(false);
    const [nickname, setNickname] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [nicknameAvailable, setNicknameAvailable] = useState(false);
    const [userIdAvailable, setUserIdAvailable] = useState(false);
  

    
      useEffect(() => {
        if (isRegisterOpen) {
          setNickname("");
          setUserId("");
          setPassword("");
          setConfirmPassword("");
        }
    
    
      }, [isRegisterOpen]);


      
   // 닉네임 중복 확인
   const checkDuplicateNickname = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/check-nickname?nickname=${nickname}`,{
        headers: {
             'X-Frontend-Request': 'true',
          },
      });
      if (!response.ok) {
        throw new Error("서버 오류");
      }
      const isUnique = await response.json();
    
      if (!isUnique) {
         showAlert("사용 가능한 닉네임입니다.");
        setNicknameAvailable(true);
      } else {
         showAlert("이미 사용 중인 닉네임입니다.");
        setNicknameAvailable(false);
      }
    } catch (error) {
      console.error("닉네임 중복 확인 오류:", error);
       showAlert("중복 확인 중 오류가 발생했습니다.");
    }
  };

  // 아이디 중복 확인
  const checkDuplicateUserId = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/check-username?username=${userId}`,{ headers: {
             'X-Frontend-Request': 'true',
          },});
      if (!response.ok) {
        throw new Error("서버 오류");
      }
      const isUnique = await response.json();
    
      if (!isUnique) {
        
         showAlert("사용 가능한 아이디입니다.");
        setUserIdAvailable(true);
      } else {
         showAlert("이미 사용 중인 아이디입니다.");
        setUserIdAvailable(false);
      }
    } catch (error) {
      console.error("아이디 중복 확인 오류:", error);
       showAlert("중복 확인 중 오류가 발생했습니다.");
    }
  };

  
  // 회원가입 API 호출
  const handleRegister = async () => {
 
    if (!userId.trim() || !nickname.trim() || !password.trim()) {
       showAlert("아이디, 닉네임, 비밀번호를 모두 입력해주세요.");
      return;
    }
  
    if (password !== confirmPassword) {
       showAlert("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!nicknameAvailable || !userIdAvailable) {
       showAlert("닉네임 또는 아이디 중복 확인을 완료해 주세요.");
      return;
    }
    const registerData = {
      username: userId,
      nickname: nickname,
      password: password,
      adminType: "대리점",
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/admin/register`, {
        method: "POST",
        headers: {
              'X-Frontend-Request': 'true',
          "Content-Type": "application/json",
        },
        body: JSON.stringify(registerData),
      });
  
      if (!response.ok) {
        throw new Error("회원가입 실패");
      }
  
  
      LoadAvailUser();
      setRegisterOpen(false);
    } catch (error) {
      console.error("회원가입 오류:", error);
       showAlert("회원가입 중 오류가 발생했습니다.");
    }
  };

  
  const {
    isAlertOpen,
    alertMessage,
    showAlert,
    closeAlert
  } = useAlertModal();


    const roleHierarchy = {
      "어드민": 0,
      "본사": 1,
      "부본사": 2,
      "대리점": 3,
    };
    const setQuickTime = (type) => {
    const now = new Date();
    const formatter = (date) => {
        const localDate = new Date(date.getTime()); // KST 기준으로 변환

        const yyyy = localDate.getFullYear();
        const mm = String(localDate.getMonth() + 1).padStart(2, "0");
        const dd = String(localDate.getDate()).padStart(2, "0");
        const hh = String(localDate.getHours()).padStart(2, "0");
        const mi = String(localDate.getMinutes()).padStart(2, "0");
        const ss = String(localDate.getSeconds()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
      };
    setActiveFilter(type);
    switch (type) {
       case "thisMonth":
      const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfThisMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59);
      setStartDate(formatter(startOfThisMonth));
      setEndDate(formatter(endOfThisMonth));
      break;

    case "lastMonth":
      const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59);
      setStartDate(formatter(startOfLastMonth));
      setEndDate(formatter(endOfLastMonth));
      break;

      case "today":
        now.setHours(0, 0, 0, 0);
        setStartDate(formatter(now));
        setEndDate(formatter(new Date()));
        break;
      case "yesterday":
        const yesterday = new Date(now.getTime() - 86400000);
        yesterday.setHours(0, 0, 0, 0);
        setStartDate(formatter(yesterday));
        const yEnd = new Date(yesterday);
        yEnd.setHours(23, 59);
        setEndDate(formatter(yEnd));
        break;
    }
  };

    const lowerRoles = Object.entries(roleHierarchy)
  .filter(([role, rank]) => rank > roleHierarchy[userInfo.adminType])
  .map(([role]) => role);

    const fetchUsers = async () => {
      try {
        const currentRole = localStorage.getItem("userType")|| "어드민"; // Admin/본사/...
        const res = await axios.get(`${API_BASE_URL}/admin/management`, {
            headers: {
    'X-Frontend-Request': 'true'
  },
          params: {
            currentRole,
            username: userInfo.username,
            page: page,
            size: size,
            searchTerm:searchTerm,
            startDate:startDate,
            endDate:endDate

          },
        });
        
       setUsers(res.data.content); // Spring의 Page 객체의 content만
       
        setTotalPages(res.data.totalPages); // 총 페이지 수 설정
      } catch (error) {
        setError(error.message); // 에러 발생 시 에러 메시지 상태에 저장
      } finally {
      setLoading(false);
    };
}

    useEffect(() => {
  fetchUsers();
}, [page,size,searchTerm,startDate,endDate]);

useEffect(() => {
  if (selectedUser) {
    if (userInfo.adminType === "어드민") {
      saveRakeRate(0); // selectedUser가 바뀐 후 실행
    }
  }
}, [selectedUser]);

const toggleStatus = async (agencyUserId, currentStatus) => {

  try {
  await axios.post(   `${API_BASE_URL}/admin/agency/toggle-status`,
  {
    agencyUserId: agencyUserId,
    active: !currentStatus
  },
  {
    headers: {
      'X-Frontend-Request': 'true',
      'Content-Type': 'application/json'
    }
  });

    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === agencyUserId ? { ...user, active: !user.active } : user
      )
    );
  } catch (err) {
    console.error("상태 변경 실패:", err);
  }
};

  // ✅ 미니탭 열기 (유저 추가)
  const openMiniTab = async () => {
    setMiniTabOpen(true);
    LoadAvailUser();
  };
 
  const LoadAvailUser = async ()=>
  {
       try {
         const currentUsername = localStorage.getItem("username") || "";
         const currentRole = localStorage.getItem("userType") || "어드민";
         const res = await axios.get(`${API_BASE_URL}/admin/available-users`, { headers: {
    'X-Frontend-Request': 'true'
  },
           params: {
             currentUsername,
             currentRole,
           },
         });
         
         setAvailableUsers(res.data);
         setFilteredUsers(res.data); // username만 추출
         setSelectedUser(null);
         setSelectedRole("대리점");
       } catch (error) {
         console.error("사용자 불러오기 실패:", error);
       }
    setSelectedUser(null);
    setSelectedRole("대리점"); // 기본값
  }
  // ✅ 미니탭 닫기
  const closeMiniTab = () => {
    setMiniTabOpen(false);
    setSearchUser("");
    setSelectedUser(null);
    setSelectedRole("대리점");
    setRakeRate(5);
  };

  // ✅ 유저 검색 필터링
  const handleSearch = (e) => {
    setSearchUser(e.target.value);
    setFilteredUsers(availableUsers.filter((user) => user.username.includes(e.target.value)));
  
  };


  // ✅ 레이크 수익 비율 조정 미니탭 열기
  const openRakeRateMiniTab = (user) => {
    setSelectedUser(user);
    setRakeRate(user.rakeRate);
    setSelectedRole(user.adminType)
    setMiniTabOpen(true);
  };

  const saveUserMemo = async (userId, memoText) => {
  try {
    await axios.post(`${API_BASE_URL}/admin/${userId}/memo`, { headers: {
    'X-Frontend-Request': 'true'
  }, params: { memo: memoText },});
    setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === userId ? { ...user, memo: memoText } : user
        )
      );
  } catch (err) {
    showAlert(err);
 
  }
};

    const saveRakeRate = (customRakeRate) => {
      
      if (!selectedUser) return;

      const payload = {
        userId: (selectedUser.user_id ? selectedUser.user_id : selectedUser.id),
        role: selectedRole,
        rakeRate: customRakeRate !== undefined ? customRakeRate : rakeRate, // 💡 전달되면 그 값 사용
        parentId: selectedParent,
      };

      fetch(`${API_BASE_URL}/admin/updateRakeRate`, {
        method: "POST",
        headers: { "Content-Type": "application/json", 'X-Frontend-Request': 'true' },
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          if (data.status === "OK") {
            closeMiniTab();
            fetchUsers();

            if (data.alerts && data.alerts.length > 0) {
              data.alerts.forEach(msg => {
                showAlert(msg);
              });
            }
          } else {
            closeMiniTab();
            fetchUsers();
            showAlert("경고: " + data.message);
          }
        })
        .catch(error => {
          showAlert("서버와의 통신에서 오류가 발생했습니다. " + error);
        });
    };
  
  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="loader"></div>
      </div>
    );
  }
  
  if (error) {
    return <ErrorScreen message={error} />;
  }

  return (
    <div id="container">
      <div className="container-inner">
        <h2>대리점 관리</h2>
        <div className="user-list">
          
      <div className="filters reverse">
      
      
          <div className="date-filters">
        
          <div className="date-buttons">
            <button 
               className={activeFilter === "yesterday" ? "active" : ""}
               onClick={() => setQuickTime("yesterday")}>어제</button>
            <button 
              className={activeFilter === "today" ? "active" : ""}
            onClick={() => setQuickTime("today")}>오늘</button>
            <button 
             className={activeFilter === "thisMonth" ? "active" : ""}
             onClick={() => setQuickTime("thisMonth")}>이번 달</button>
            <button 
               className={activeFilter === "lastMonth" ? "active" : ""}
               onClick={() => setQuickTime("lastMonth")}>지난 달</button>
          </div>
          <div className="date-inputs">
              <input type="datetime-local" value={startDate} onChange={(e) => {setStartDate(e.target.value);setQuickTime("");}} />
              <input type="datetime-local" value={endDate} onChange={(e) => {setEndDate(e.target.value);setQuickTime("");}} />
          </div>
      <div className="user-list__search">
                <input
                  type="text"
                  placeholder="아이디 또는 닉네임 검색"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>
        </div>
    
       
            </div>
          <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>이름</th>
              <th>현재 보유 포인트</th>
              <th>접속 시간 / 등록 날짜</th>
              {/* 어드민이 아니면 레이크 수익 비율 컬럼 헤더 표시 */}
              {userInfo.adminType !== "어드민" && <th>레이크 수익 비율</th>}
              <th>상세보기</th>
              <th>관리</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              <>
                {users.map((user) => (
                  <tr key={user.username}>
                    <td>{user.username}</td>
                    <td>{user.nickname}({user.createdByNickname})</td>
                    <td>{user.egg}</td>
                    <td>{user.lastLoginTime + " / " + user.registeredAt}</td>

                    {/* 어드민이 아니면 레이크 수익 비율 및 조정 버튼 표시 */}
                    {userInfo.adminType !== "어드민" && (
                      <td>
                        {user.rakeRate}%
                        <button
                          className="btn-rake-rate"
                          onClick={() => { openRakeRateMiniTab(user) }}
                        >
                          조정
                        </button>
                      </td>
                    )}

                    <td>
                      <button
                        className="btn-detail"
                        onClick={() => {
                          setDetailUser(user);
                          setMemo(user.memo || "");
                          setShowDetailPopup(true);
                        }}
                      >
                        상세보기
                      </button>
                    </td>
                    <td>
                      <button
                        className={`btn-toggle ${user.active ? "active" : "inactive"}`}
                        onClick={() => toggleStatus(user.id, user.active)}
                      >
                        {user.active ? "활성화" : "비활성화"}
                      </button>
                    </td>
                  </tr>
                ))}
              </>
            ) : (<></>)}
          </tbody>
          </table>
          { users.length == 0 ? (
            
            <div className="empty-state">
              <i className="fa-solid fa-store"></i>
              <p className="title">관리하는 대리점이 존재하지 않습니다</p>
            </div>
        ):(<></>)}
       
        </div>

        {/* ✅ 추가 버튼 */}
        <button className="btn-add" onClick={openMiniTab}>+ 추가</button>

        { users.length > 0 ? (
                  <>
        <div className="pagination">
            <button
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
            >
              ◀
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={i === page ? "active" : ""}
                onClick={() => setPage(i)}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={page === totalPages - 1}
              onClick={() => setPage(page + 1)}
            >
              ▶
            </button>
          </div></>):<></>}
       
      
       {/* ✅ 아이디 검색 미니탭 */}
          {isMiniTabOpen && !selectedUser && (
            <div className="mini-tab-overlay">
              <div className="mini-tab" onClick={(e) => e.stopPropagation()}>
                <div className="mini-tab-content">

              


                  <h3>아이디 검색</h3>
                   <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5rem" }}>
                  <button
                    className="btn-secondary"
                    onClick={() => setRegisterOpen(true)}
                    style={{
                      width:"100px",
                      padding: "4px 8px",
                      borderRadius: "6px",
                    }}
                  >
                    ➕ 신규 등록
                  </button>
                </div>
                  <input
                    type="text"
                    value={searchUser}
                    onChange={handleSearch}
                    placeholder="아이디 입력"
                  />
                  <ul>
                  {filteredUsers.length === 0 ? (
                       <li className="no-results">
                       🔍 검색된 유저가 없습니다.
                     </li>
                      ) : (
                        filteredUsers.map((user) => (
                          <li
                            key={user.id}
                            className={tempSelectedUser === user ? "selected" : ""}
                            onClick={() => {
                            
                              setTempSelectedUser(user);    // '임시 선택'만 하기
                                 
                                setSearchUser(user.username); // 검색창에 이름 넣기
                         
                               
                            }}
                          >
                            {user.username}
                          </li>
                        ))
                      )}
                  </ul>

                  {/* ✅ 권한 선택 드롭다운 */}
                  <div className="role-select">
                    <label>권한 선택:</label>
                    <select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
                      {lowerRoles.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    className="btn-primary"
                    onClick={() => {
                      if (tempSelectedUser) {
                        setSelectedUser(tempSelectedUser); // 진짜로 유저 선택!
                       
                      }
                    }}
                  >
                    추가
                  </button>
                  <button className="btn-primary-outline" onClick={closeMiniTab}>닫기</button>
                </div>
              </div>
            </div>
          )}

          {/* ✅ 레이크 수익 비율 조정 미니탭 */}
        {isMiniTabOpen && selectedUser && userInfo.adminType !== "어드민" && (
            <div className="mini-tab-overlay" onClick={closeMiniTab}>
              <div className="mini-tab" onClick={(e) => e.stopPropagation()}>
                <div className="mini-tab-content">
                  <h3>{selectedUser.username}님의 레이크 수익 비율 조정</h3>

                  {/* 슬라이더 */}
                  <input
                    type="range"
                    min="0.0"
                    max="100.0"
                    step="0.1"
                    value={rakeRate}
                    onChange={(e) => setRakeRate(Number(e.target.value))}
                  />

                  {/* 설정 표시 및 숫자 입력 필드 */}
                  <div className="rake-rate-display">
                    <span>현재 설정:</span>
                    <input
                      type="number"
                      min="0.0"
                      max="100.0"
                      step="0.1"
                      value={rakeRate}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (value >= 0 && value <= 100) {
                          setRakeRate(value);
                        }
                      }}
                      className="rake-rate-stealth-input"
                    />
                    <span>%</span>
                  </div>

                  <button className="btn-primary" onClick={()=>saveRakeRate(rakeRate)}>저장</button>
                  <button className="btn-primary-outline" onClick={closeMiniTab}>닫기</button>
                </div>
              </div>
            </div>
          )}

          {showDetailPopup && detailUser && (
            <div className="popup-overlay" >
              <div className="popup" onClick={(e) => e.stopPropagation()}>
                <div className="user-info-card">
                  <h4>{detailUser.nickname} ({detailUser.username})</h4>
                  <p><strong>권한:</strong> {detailUser.adminType}</p>
                  <p><strong>등록일:</strong> {detailUser.registeredAt}</p>
                  <p><strong>최근 접속:</strong> {detailUser.lastLoginTime}</p>
                  <p><strong>보유 알:</strong> {detailUser.egg}</p>
                </div>
                <div className="memo-section">
                  <label>관리 메모:</label>
                  <textarea
                    value={memo}
                    onChange={(e) => setMemo(e.target.value)}
                    rows={4}
                    placeholder="여기에 메모를 작성하세요"
                  />
                </div>

                <button className="btn-primary" onClick={() => {
                  // 백엔드 저장 함수 호출
                  saveUserMemo(detailUser.id, memo);
                  setShowDetailPopup(false);
                }}>저장</button>
                <button className="btn-primary-outline" onClick={() => setShowDetailPopup(false)}>닫기</button>
              </div>
            </div>
          )}
      </div>

        {/* 회원가입 모달 */}
        <Modal id="modalRegister" isOpen={isRegisterOpen} closeModal={() => setRegisterOpen(false)}>
          <form className="form-area">
            <div className="form-item">
              <label>닉네임</label>
              <div className="input-group">
                <input
                  type="text"
                  value={nickname}
                  onChange={(e) => {setNickname(e.target.value);setNicknameAvailable(false);}} // nickname 상태 설정
                />
                 <button type="button" className="btn-check" onClick={checkDuplicateNickname}>중복 확인</button>
              </div>
            </div>
          
            <div className="form-item">
              <label>아이디</label>
              <div className="input-group">
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => {setUserId(e.target.value);setUserIdAvailable(false);}} // userId 상태 설정
                />
                  <button type="button" className="btn-check" onClick={checkDuplicateUserId}>중복 확인</button>
              </div>
            </div>

            <div className="form-item">
              <label>비밀번호</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // password 상태 설정
             
              />
            </div>

            <div className="form-item">
              <label>비밀번호 확인</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} // confirmPassword 상태 설정
              />
            </div>

            <button type="button"
              className="btn-primary"
              onClick={handleRegister} // 회원가입 로직 추가
              style={{ backgroundColor: "#2ecc71" }}
            >
              회원가입
            </button>
            <button type="button" className="btn-primary-outline" onClick={() => setRegisterOpen(false)}>닫기</button>
          </form>
        </Modal>

       {isAlertOpen && <AlertModal message={alertMessage} onClose={closeAlert} />}

       
    </div>
    
  );
};

export default AgencyManagement;
